import React from 'react';

import {
  ReferenceArrayField,
  ReferenceArrayInput,
} from 'react-admin';

import EditFieldLayout from '../components/layout/EditFieldLayout';

const EditReferenceArray = ({
  source,
  label,
  showEdit,
  reference,
}: {
  showEdit: boolean;
  source: string;
  label: string;
  reference: string;
}) => (
  <EditFieldLayout
    source={source}
    label={label}
    showEdit={showEdit}
    fieldElement={(
      <ReferenceArrayField source={source} reference={reference} emptyText="-" />
    )}
    inputElement={(
      <ReferenceArrayInput reference={reference} label="" source={source} helperText={false} />
    )}
  />
);

export default EditReferenceArray;
